<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarPortal",
	data: () => ({
		menuItems: [
			{ title: "Audit", link: "/audit" },
			{ title: "Audit Flow-Down", link: "/auditflowdown" },
			{ title: "Trace", link: "/trace" },
			{ title: "Sustainability", link: "/csr"},
			{ title: "Co2 Calculator", link: "/emissions"},
			{ title: "Connections", link: "/connections" },
			{ title: "Supplier Performance", link: "/supplier-performance" },
		],
		sidebar: false
	})
}
</script>